import React from 'react';
import type { FeatureGrid as FeatureGridType } from '@sy/ssr-types';
import FeatureGrid from '../../../components/FeatureGrid';
import { featureImages, type FeatureType } from '../../assets/imageImports';

interface FeatureGridWrapperProps {
	feature: FeatureType;
	featureGrid: FeatureGridType;
}

const FeatureGridWrapper: React.FC<FeatureGridWrapperProps> = ({
	feature,
	featureGrid,
}) => {
	const images = featureImages[feature];
	if (!images) {
		return null;
	}

	const iconImages = images.featureGridIconImages;
	if (!iconImages) {
		return null;
	}

	const featuresWithIcons = featureGrid.features.map(item => ({
		iconSrc: iconImages[item.iconImage as keyof typeof iconImages] || '',
		titleKey: item.titleKey,
		descriptionKey: item.descriptionKey,
	}));

	return (
		<FeatureGrid
			titleKey={featureGrid.titleKey}
			subtitleKey={featureGrid.subtitleKey}
			features={featuresWithIcons}
		/>
	);
};

export default FeatureGridWrapper;
